import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import LatestProducts from '../components/sections/LatestProducts';
import Categories from '../components/sections/Home-page-categories';
import Testimonials from '../components/sections/Testimonials';
import SEO from '../components/SEO';
import OrganizationSchema from '../components/OrganizationSchema';
import { useTranslation } from 'react-i18next';

const Home: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t('seo.home.title')}
        description={t('seo.home.description')}
      />
      <OrganizationSchema />
      <div className='relative'>
        <div className="container max-w-[min(90vw,1400px)] md:max-w-[min(80vw,1400px)] mx-auto">
          <HeroSection />
          <LatestProducts />
          <Categories />
        </div>
        <div className="w-full">
          <Testimonials />
          <AboutSection />
        </div>
      </div>
    </>
  );
};

export default Home;
